import { environment } from './environment';

const defaultFileNames = {
  // 1
  'course.imposingTheStructure': 'Lecture 1A_Imposing the Structure_11.08.20.mp4',
  'course.pickingOutThePoints': 'Lecture 1B_Cementing the Rules_11.08.20.mp4',
  'course.cementingTheRules': 'Lecture 1C_Picking Out the Points_12.08.20.mp4',
  'course.graspingTheMessage_1': 'Lecture 1D - Grasping the Message_13.08.20.mp4',
  'course.graspingTheMessage_2': 'Lecture 1D-2_Finding the Summary Point_27.08.20.mp4',
  // 2
  'course.ideasFitTogether_1': 'Lecture 2A_How the Ideas Fit Together_31.08.20.mp4',
  'course.ideasFitTogether_2': 'Lecture 2A - 2_Identify First Idea_07.09.20.mp4',
  'course.creatingQuestion': 'Lecture 2B_Creating a Question Answer Dialogue_12.09.20.mp4',
  // 3
  'course.deductiveReasoning': 'Lecture 3A - 1_ Deductive Arguments_12.09.20.mp4',
  'course.inductiveReasoning': 'Lecture 3B - 1_ Inductive Reasoning_13.09.20.mp4',
  'course.deductionToInduction': 'Lecture 3B - 4_Transforming Deduction to Induction_14.09.20.mp4',
  'course.avoidingDeductiveArguments': 'Lecture 3C_Avoiding Deductive Arguments_14.09.20.mp4',
  // 4
  'course.practiceInSeeing': 'Lecture 4A_Introductions - Reading to Get the Rhythm_16.09.20.mp4',
  'course.findingReadersQuestion': 'Lecture 4B - 1_Seeing the SCQ Structure_22.09.20.mp4',
  'course.spottingSCQ': 'Lecture 4B-2_Finding the Reader_s Question_22.09.20.mp4',
  'course.applyingSCQProcess': 'Lecture 4C-1_Applying the SCQ Process_23.09.20.mp4',
  'course.practiceInSeeing3': 'Lecture 4C-2_Field_Sales_Meeting_22.11.20.mp4',
  // 5
  'course.defineProblem': 'Lecture 5A_How to Define a Problem_27.09.20.mp4',
  'course.practiceDefiningProblem': 'Lecture 5B_Defining the Problem_27.09.20.mp4',
  'course.definingMoreComplexProblems': 'Lecture 5C_Converting an Introduction_27.09.20.mp4',
  'course.writingAGoodProposal': 'Lecture 5D_Writing Proposals and Project Plans_29.09.20.mp4'
}

export default class CourseVideoService
{
  constructor ( $state )
  {
    'ngInject';

    Object.assign( this, { $state, s3Url: environment.videosUrl, fileNames: defaultFileNames } );
  }

  getFileURL ( modifier = '' )
  {
    const currentUrl = this.$state.current.name + modifier;
    let fileName = this.fileNames[ currentUrl ] || 'oceans.mp4';
    return environment.videosUrl + fileName
  }
}



// WEBPACK FOOTER //
// ./client/app/services/courseVideo.service.js